import { useCommonDetailsContext } from "../context/Common/common";

export const tokens = {
  colors: {
    // Brand
    connectedPurple: "#001a77",
    modernBlue: "#0057bf",
    approachableBlue: "#00a5be",
    innovativeGreen: "#66cc33",

    // Neutrals
    offWhite: "#ffffff",
    midGrey: "#C0BEC2",
    grey: "#636363",
    offBlack: "#212121",
    white: "#FFFFFF",
    
    // Form states
    error: "#D32F2F",
    success: "#1BA973",
  },

  gradients: {
    header: "linear-gradient(247.49deg, #552791 46.78%, #432568 98.43%)",
    rainbow:
      "linear-gradient(90deg, #2BAF7D 0%, #00A6BE 33%, #5C50F3 66%, #432568 100%)",
  },

  radius: {
    card: 10,
    input: 10,
    pill: 999,
    circle: "50%",
  },

  spacing: {
    xs: 8,
    sm: 12,
    md: 16,
    lg: 24,
    xl: 32,
  },

  typography: {
    fontFamily:
      "'Roboto', sans-serif",
    weights: {
      medium: 500,
      extraBold: 800,
      black: 900,
    },
  },
};

export const useActiveBranding = () => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  if (validateParentData?.isSingleParent) {
    return publishedBranding;
  }
  return clientScopedBranding || publishedBranding;
};

export const useTokens = () => {
  const activeBranding = useActiveBranding();
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;

  return {
    ...tokens,
    colors: {
      ...tokens.colors,
      connectedPurple: primaryColor,
    },
    primaryColor,
  };
};

export const usePrimaryColor = () => {
  const activeBranding = useActiveBranding();
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  return primaryColor;
};

export default tokens;